module.exports = __webpack_public_path__ + "static/media/g-6.7d526d95.jpg";